import React, { useMemo, useState } from "react";
import { Box, Button, FormControl, Grid, Card, TextField, IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import dayjs from "dayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import AppLoading from "verticales/AppLoading.tsx";
import fetchData from "verticales/FetchData";
import TableMaestros from "verticales/TableMaestrosBackupCreator.tsx";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Tooltip from "@mui/material/Tooltip";
import UtilModal from "verticales/UtilModal.js";
import CreateClient from "../backupCreator/createClient";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ViewClient from "../backupCreator/clientViewTabs";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.MuiMultiSectionDigitalClockSection-item": {
            fontSize: "1rem", // Change font size
            // color: "blue", // Change text color
            // backgroundColor: "lightyellow", // Change background color
          },
        },
      },
    },
  },
});

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "backup-creator";

const Example = (props) => {
  const [client, setClient] = React.useState("");
  const [fechaIni, setFechaIni] = React.useState(dayjs(new Date()));
  const [fechaFin, setFechaFin] = React.useState(dayjs(new Date()));
  const [data, setData] = React.useState([]);
  const [blocking, setBlocking] = React.useState(false);
  const [msgAction, setMsgAction] = React.useState(context);
  const [urlPresigned, setUrlPresigned] = React.useState({});

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const handleButtonClick = async () => {
    const dateIni = fechaIni ? fechaIni.toDate() : null;
    const dateFin = fechaFin ? fechaFin.toDate() : null;

    const params = {
      action: "get-client",
      object: {
        client,
        fechaIni: dateIni,
        fechaFin: dateFin,
      },
    };

    console.log(params);

    setBlocking(true);
    setMsgAction("Buscando cliente....");

    try {
      const resp = await fetchData(url, context, params);
      console.log(resp);
      console.log(resp.rows);
      setData(resp.rows);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setData([]);
    } finally {
      setBlocking(false);
    }
  };

  const getDocumentUrl = async (row) => {
    console.log(row.original);
    const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
    const action = "backup-creator";

    const params = {
      action: "get-url",
      object: {
        nit: row.original.nit,
        razon_social: row.original["razon_social"],
      },
    };

    console.log("Datos cliente.....", params);

    try {
      const getUrl = await fetchData(url, action, params);
      console.log("get url......", getUrl);
      window.open(getUrl);
      setUrlPresigned(getUrl);
    } catch (er) {
      console.log("Error....", er);
    }
  };

  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalClient, setOpenModalClient] = React.useState(false);
  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  const handleOpenModalClient = (row) => {
    setRowSelect(row);
    setOpenModalClient(true);
  };

  const handleCloseModalClient = () => {
    setOpenModalClient(false);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  /** datos table maestros11 */
  const columns = useMemo(
    () => [
      { header: "Nit", accessorKey: "nit" },
      { header: "Razon Social", accessorKey: "razon_social" },
      { header: "Private Key", accessorKey: "private_key" },
      { header: "Ruta Bucket", accessorKey: "key_url_presigned" },
      { header: "Fecha Creacion", accessorKey: "fecha_creacion" },
    ],
    []
  );

  const renderViewGet = () => {
    return <ViewClient row={rowSelect} handleCloseModal={handleCloseModal} />;
  };

  const renderViewClient = () => {
    return <CreateClient handleCloseModal={handleCloseModalClient} />;
  };

  let renderOpcRowsSid = (row) => {
    if (row.original["key_url_presigned"] != null) {
      return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
          <Tooltip title="Descargar">
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                getDocumentUrl(row);
              }}
              href={urlPresigned}
            >
              <CloudDownloadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Ver Cliente">
            <IconButton onClick={(e) => handleOpenModal(row)}>
              <AccountBoxIcon />
            </IconButton>
          </Tooltip>
        </Box>
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={6} lg={12}>
                <MDBox m={1}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 2,
                        alignItems: "center",
                        justifyContent: "flex-start",
                        p: 2,
                      }}
                    >
                      <TextField
                        value={client}
                        id="client"
                        label="Nit"
                        onChange={(event) => setClient(event.target.value)}
                        sx={{ minWidth: 200 }}
                      />

                      <ThemeProvider theme={theme}>
                        <DateTimePicker
                          label="Inicial timestamp"
                          onChange={(newValue) => setFechaIni(newValue)}
                          value={fechaIni}
                          inputFormat="dd/MM/yyyy hh:mm a"
                          ampm
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              sx={{
                                minWidth: 230,
                                "& .MuiInputBase-input": {
                                  padding: "12px",
                                  fontSize: 13,
                                },
                              }}
                            />
                          )}
                        />

                        <DateTimePicker
                          label="Final timestamp"
                          onChange={(newValue) => setFechaFin(newValue)}
                          value={fechaFin}
                          inputFormat="dd/MM/yyyy hh:mm a"
                          ampm
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              sx={{
                                minWidth: 230,
                                "& .MuiInputBase-input": {
                                  padding: "12px",
                                  fontSize: 13,
                                },
                              }}
                            />
                          )}
                        />
                      </ThemeProvider>

                      <MDButton
                        variant="contained"
                        disableElevation
                        onClick={handleButtonClick}
                        sx={{ height: 40 }}
                      >
                        Buscar
                      </MDButton>
                    </Box>
                  </LocalizationProvider>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox m={1}>
                  {blocking ? (
                    <AppLoading {...props} titleCustom={msgAction} />
                  ) : (
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      height={320}
                      handleOpenModalClient={handleOpenModalClient}
                      handleOpenModal={handleOpenModal}
                      renderOpcRows={renderOpcRowsSid}
                    />
                  )}
                </MDBox>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderViewGet}
      />
      <UtilModal
        openModal={openModalClient}
        handleCloseModal={handleCloseModalClient}
        renderView={renderViewClient}
      />
    </DashboardLayout>
  );
};

export default Example;
